import React, { useMemo } from "react"
import { Designation, Frequency } from "../types"
import { designationTotalCents } from "../utils/designationTotal"
import { Loading } from "./Loading"
import { StripePaymentElement } from "./StripePaymentElement"

type PaymentMethodSelectorProps = {
  designations: Designation[]
  frequency: Frequency
}

export function PaymentMethodSelector({
  designations,
  frequency,
}: PaymentMethodSelectorProps) {
  const amountCents = useMemo(
    () => designationTotalCents(designations),
    [designations],
  )

  return (
    <div>
      <h2>Payment method</h2>
      <React.Suspense fallback={<Loading />}>
        <StripePaymentElement {...{ amountCents, frequency }} />
      </React.Suspense>
    </div>
  )
}
